import React from "react";
import PropTypes from "prop-types";
// Material Imports
import Typography from "@mui/material/Typography";
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import { withi18n } from "../../../../../customer/components";
import { formatRating } from "@limitless/common/utils";
import { USER_TYPE_GENAI } from "../../../../utils/Constants";
const ExpertRating = ({
  expertInfo,
  classes,
  t,
  showExpertRating,
  author,
  userType
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, showExpertRating && /*#__PURE__*/React.createElement("div", {
    className: classes.authorRatingArea
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "textPrimary"
  }, author && (userType === USER_TYPE_GENAI ? t("{0} (AI Expert)", author) : t("{0}", author))), expertInfo && /*#__PURE__*/React.createElement(Typography, {
    className: classes.ratingText,
    variant: "caption",
    color: "textPrimary"
  }, t("{0} answers |", expertInfo.answerCount || 0), " ", t("{0} rating", formatRating(expertInfo.rating) || "n/a"))));
};
const styles = {
  authorRatingArea: {
    display: "flex",
    flexDirection: "row",
    marginTop: 16,
    flexWrap: "nowrap",
    justifyContent: "space-between"
  },
  ratingText: {
    marginLeft: 16
  }
};
export default withStyles(styles)(withi18n(ExpertRating));
ExpertRating.propTypes = {
  expertInfo: PropTypes.object,
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  showExpertRating: PropTypes.bool.isRequired,
  author: PropTypes.string.isRequired,
  userType: PropTypes.string.isRequired
};